import { Link } from 'react-router-dom';
import { type FC } from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
`;
const FooterInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1rem;
  @media (min-width: 640px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const Col = styled.div``;
const Logo = styled.img`
  height: 2rem;
  width: auto;
  margin-bottom: 1rem;
`;
const ColTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
`;
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const ListItem = styled.li`
  margin-bottom: 0.75rem;
`;
const StyledLink = styled(Link)`
  color: #6b7280;
  text-decoration: none;
  font-size: 1rem;
  &:hover {
    color: #111827;
  }
`;
const Copyright = styled.div`
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
`;
const CopyrightText = styled.p`
  color: #9ca3af;
  font-size: 0.875rem;
  text-align: center;
`;

export const Footer: FC = () => {
  return (
    <FooterContainer>
      <FooterInner>
        <Grid>
          {/* 公司信息 */}
          <Col>
            <Logo src="/logo.svg" alt="Sensforge" />
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              Empowering developers with innovative solutions.
            </p>
          </Col>
          {/* 快速链接 */}
          <Col>
            <ColTitle>Product</ColTitle>
            <List>
              <ListItem>
                <StyledLink to="/features">Features</StyledLink>
              </ListItem>
              <ListItem>
                <StyledLink to="/pricing">Pricing</StyledLink>
              </ListItem>
            </List>
          </Col>
          {/* 资源 */}
          <Col>
            <ColTitle>Resources</ColTitle>
            <List>
              <ListItem>
                <StyledLink to="/docs">Documentation</StyledLink>
              </ListItem>
              <ListItem>
                <StyledLink to="/blog">Blog</StyledLink>
              </ListItem>
            </List>
          </Col>
          {/* 法律 */}
          <Col>
            <ColTitle>Legal</ColTitle>
            <List>
              <ListItem>
                <StyledLink to="/privacy">Privacy Policy</StyledLink>
              </ListItem>
              <ListItem>
                <StyledLink to="/terms">Terms of Service</StyledLink>
              </ListItem>
              <ListItem>
                <StyledLink to="/cookie-policy">Cookie Policy</StyledLink>
              </ListItem>
            </List>
          </Col>
        </Grid>
        {/* 版权信息 */}
        <Copyright>
          <CopyrightText>
            © {new Date().getFullYear()} Sensforge Inc. All rights reserved.
          </CopyrightText>
        </Copyright>
      </FooterInner>
    </FooterContainer>
  );
};
